class Type {
	public static THIRTY = new Type("30 Days", 30);
	public static SIXTY = new Type("60 Days", 60);
	public static NINETY_PLUS = new Type("90+ Days", 90);
	public static JUST_BROWSING = new Type("Just Browsing", 1);

	private constructor(public id: string, public value: number) {}

	public get label() {
		return this.id;
	}

	public get bookmarked() {
		return this === Type.THIRTY;
	}

	public get type() {
		return Type.leadTimelineValues().includes(this);
	}

	public static values(): Type[] {
		return Object.values(Type);
	}

	public static leadTimelineValues(): Type[] {
		return [Type.THIRTY, Type.SIXTY, Type.NINETY_PLUS, Type.JUST_BROWSING];
	}

	public static leadTimelineLabels(): string[] {
		return [
			Type.THIRTY.label,
			Type.SIXTY.label,
			Type.NINETY_PLUS.label,
			Type.JUST_BROWSING.label,
		];
	}

	public static getById(id: string) {
		return this.values().find(
			(value) => value.id.toLowerCase() === id.toLowerCase()
		);
	}

	public static getByLabel(label: string) {
		return this.values().find(
			(value) => value.label.toLowerCase() === label.toLowerCase()
		);
	}
}

export { Type as LeadTimelineType };
